/**
 * PowerArQ Sticky Cart & Desktop Widget (Refined)
 * V2: Advanced Multi-Step Variant Selector
 */

class PowerArQStickyCart {
    constructor() {
        this.config = {
            position: 'left-bottom',
            zIndex: 2147483647,
        };

        this.state = {
            isOpen: false,
            product: window.powerarqCartWidgetConfig?.product || null,
            isMobile: window.matchMedia('(max-width: 767px)').matches,
            // Selection State
            selectedOptions: {}, // { "Color": "Black", "Size": "M" }
            currentVariant: null,
            // 各コンテキストの数量を保持（モーダル再描画でリセットされないように）
            quantities: { desktop: 1, mobile: 1, modal: 1 }
        };

        // Resize listener
        window.addEventListener('resize', () => {
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            if (this.state.isMobile !== isMobile) {
                this.state.isMobile = isMobile;
                this.reRender();
            }
        });

        document.addEventListener('powerarq:restock-status', () => this.updateRestockStatus());
        // ページ側でバリエーションを選び直したら、追従ウィジェットの価格も合わせる（2026-10-21）。
        // ページのJSは select[name=id] の change を dispatchEvent でも jQuery の .change() でも発火するため両方で拾う
        // ページのJSは読み込み時にも1つ目の色を自動で選んで change を流す（2軸商品）。それは「選択」ではないので、
        // ユーザーが一度でも画面に触れた後だけ追従する（ページ側も選ぶまでは価格帯の表示のまま／購入モーダルも選ぶまで空のまま）
        // 「触れた」はバリエーションの選択UI（購入フォーム・色/サイズ/オプションのボタン）に限る。
        // 画面のどこかをスクロールしただけで自動選択の1色目に追従してしまっていたため（2026-10-21 レビュー指摘）
        this.userInteracted = false;
        const SELECTOR_UI = 'form[action*="/cart/add"], .two-step-variant-selector, .variant-step, .DummyRadioSelecterLabel, .size-button, .option-item, .DummyRadioSelecter';
        const markInteracted = event => {
            if (!event.target || !event.target.closest || !event.target.closest(SELECTOR_UI)) return;
            this.userInteracted = true;
            ['pointerdown', 'keydown', 'touchstart'].forEach(t => document.removeEventListener(t, markInteracted, { capture: true }));
        };
        ['pointerdown', 'keydown', 'touchstart'].forEach(t => document.addEventListener(t, markInteracted, { capture: true, passive: true }));
        const onPageVariantChange = event => {
            if (!this.userInteracted) return;
            const t = event.target;
            if (t && t.matches && t.matches('form[action*="/cart/add"] [name="id"]')) this.syncWithPageVariant();
        };
        document.addEventListener('change', onPageVariantChange);
        if (window.jQuery) window.jQuery(document).on('change', 'form[action*="/cart/add"] [name="id"]', onPageVariantChange);
        // 安全網: ページ側は dispatchEvent／jQuery の .change()／値の直接代入（電熱4商品のサイズ）と流し方がバラバラで、
        // 上の監視だけでは拾えない経路がある（1軸の画像カードは jQuery の .change() でネイティブの change 監視に届かない）。
        // select の値を 0.4 秒ごとに読んで、変わっていたら合わせる（読み取り1回だけの軽い処理）
        // 直前に見た値と比べる（同期できない値のときに毎回 syncWithPageVariant が走り続けないように）
        this.lastSeenSelectValue = null;
        setInterval(() => {
            if (!this.userInteracted) return;
            const sel = document.querySelector('form[action*="/cart/add"] [name="id"]');
            if (!sel || !sel.value || String(sel.value) === String(this.lastSeenSelectValue)) return;
            this.lastSeenSelectValue = sel.value;
            this.syncWithPageVariant();
        }, 400);
        document.addEventListener('input', event => {
            if (event.target.matches('#RestockNotifyForm input[type="email"]')) {
                const stickyInput = this.elements?.container.querySelector('.pasc-restock-email');
                if (stickyInput) stickyInput.value = event.target.value;
            }
        });
        this.init();
    }

    init() {
        // 電熱4商品: オプション同時購入(プルダウン)を廃止しサイズのみに。
        // ベース(単品=SKUに「-」を含まない)変種＋サイズ軸のみに絞る。SKU/商品データは不変(表示のみ)。
        var ELECTRIC = ['voltera-jacket', 'voltera-pants', 'powerarq-electric-heated-gloves', 'voltera-gloves'];
        this.isElectric = this.state.product && ELECTRIC.indexOf(this.state.product.handle) !== -1;
        if (this.isElectric) {
            var base = (this.state.product.variants || []).filter(function (v) { return (v.sku || '').indexOf('-') === -1; });
            if (base.length) this.state.product.variants = base;
            if (this.state.product.options && this.state.product.options.length > 1) {
                this.state.product.options = [this.state.product.options[0]];
            }
            this.state.crossSell = [];
            this.state.crossChecked = {};
            this.loadCrossSell(this.state.product.handle);
        }
        this.createWidgetDOM();
        if (this.state.product) {
            // Pre-select first variant if available? Or leave empty?
            // Usually better to leave empty to force user choice if multiple variants.
            // If only 1 variant, select it.
            if (this.state.product.variants.length === 1) {
                this.state.currentVariant = this.state.product.variants[0];
            }
        }
    }

    reRender() {
        if (this.stickySizeObserver) this.stickySizeObserver.disconnect();
        // 作り直した価格欄にもう一度描画させる（同じバリエーションだと syncWithPageVariant が何もしないため）
        this.lastSyncedVariantId = null;
        if (this.elements && this.elements.container) {
            this.elements.container.remove();
        }
        this.createWidgetDOM();
    }

    // 同時購入(合わせ買い)候補を事前ロード。電熱4商品のみ
    loadCrossSell(handle) {
        // デフォルトは全てチェック無し(事前チェック済みの有料オプションはクレーム/法的リスクのため)
        var MAP = {
            'voltera-jacket': [['kxgl-b26g', false], ['vjp-pb-ic08m', false]],
            'voltera-pants': [['kxgl-b26g', false], ['vjp-pb-ic08m', false]],
            'powerarq-electric-heated-gloves': [['powerarq-electric-heated-gloves-battery-typec', false], ['powerarq-usb-typc', false]],
            'voltera-gloves': [['powerarq-electric-heated-gloves-battery-typec', false], ['powerarq-usb-typc', false]]
        };
        var NAMES = {
            'kxgl-b26g': 'モバイルバッテリー 111Wh', 'vjp-pb-ic08m': '接続ケーブル（延長用）',
            'powerarq-electric-heated-gloves-battery-typec': 'グローブ用 予備バッテリー',
            'powerarq-usb-typc': 'グローブ稼働用 Type-Cケーブル'
        };
        var list = MAP[handle] || [];
        var order = list.map(function (x) { return x[0]; });
        var self = this;
        list.forEach(function (pair) {
            var h = pair[0], on = pair[1];
            self.state.crossChecked[h] = on;
            fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
                if (!p) return;
                var av = (p.variants || []).filter(function (v) { return v.available; });
                var img = p.featured_image || (p.images && p.images[0]) || '';
                self.state.crossSell.push({
                    handle: h, name: NAMES[h] || p.title,
                    price: (av[0] || p.variants[0]).price,
                    img: img, variantId: av.length ? av[0].id : null, available: av.length > 0,
                    order: order.indexOf(h)
                });
                self.state.crossSell.sort(function (a, b) { return a.order - b.order; });
                var modalEl = document.getElementById('pasc-variant-modal');
                if (self.modalContent && modalEl) self.renderModalContent(self.modalContent, modalEl);
            }).catch(function () {});
        });
    }

    // モーダル内の同時購入セクション
    renderCrossSell(scrollArea) {
        if (!this.isElectric || !this.state.crossSell || !this.state.crossSell.length) return;
        var self = this;
        var box = document.createElement('div');
        box.className = 'pasc-cross';
        var title = document.createElement('div');
        title.className = 'pasc-cross-title';
        title.textContent = '一緒に購入がおすすめ';
        box.appendChild(title);
        this.state.crossSell.forEach(function (it) {
            var row = document.createElement('label');
            row.className = 'pasc-cross-row' + (it.available ? '' : ' is-out');
            var checked = self.state.crossChecked[it.handle] && it.available;
            var imgSrc = it.img ? it.img.replace(/\.([^.?]+)(\?|$)/, '_80x80.$1$2') : '';
            row.innerHTML = '<input type="checkbox" data-pasc-cross data-vid="' + (it.variantId || '') + '"' + (checked ? ' checked' : '') + (it.available ? '' : ' disabled') + '>' +
                '<img class="pasc-cross-img" src="' + imgSrc + '" alt="" loading="lazy">' +
                '<span class="pasc-cross-name">' + it.name + '</span>' +
                '<span class="pasc-cross-price">' + (it.available ? self.formatMoney(it.price) : '完売') + '</span>';
            var cb = row.querySelector('input');
            cb.addEventListener('change', function (e) { self.state.crossChecked[it.handle] = e.target.checked; });
            box.appendChild(row);
        });
        scrollArea.appendChild(box);
    }

    createWidgetDOM() {
        const container = document.createElement('div');
        container.id = 'powerarq-sticky-cart';
        container.className = 'pasc-container';

        // モバイルとデスクトップ両方で商品ページならスティッキーバーを表示
        if (this.state.product) {
            if (this.state.isMobile) {
                this.renderMobileStickyBar(container);
            } else {
                this.renderDesktopStickyBar(container);
            }
        }

        document.body.appendChild(container);
        this.elements = { container };
        // LINEバナーがメール入力欄付きの追従バーに重ならないよう、実際の高さを共有。
        if (this.state.isMobile && this.state.product) {
            const syncHeight = () => document.documentElement.style.setProperty('--cta-height', container.getBoundingClientRect().height + 'px');
            syncHeight();
            if (window.ResizeObserver) {
                this.stickySizeObserver = new ResizeObserver(syncHeight);
                this.stickySizeObserver.observe(container);
            }
        } else {
            document.documentElement.style.removeProperty('--cta-height');
        }
        this.updateRestockStatus();
    }

    // --- Mobile Sticky Bar ---
    renderMobileStickyBar(container) {
        container.classList.add('pasc-mobile-sticky');
        const wrapper = document.createElement('div');
        wrapper.className = 'pasc-sticky-wrapper';

        const avatar = document.createElement('div');
        avatar.className = 'pasc-sticky-avatar';
        const img = document.createElement('img');
        img.src = window.powerarqCartWidgetConfig?.iconUrl || '';
        img.alt = 'Advisor';
        avatar.appendChild(img);

        const qtyStepper = this.createQtyStepper('mobile');

        const btn = document.createElement('button');
        btn.className = 'pasc-sticky-btn';

        // 完売(全バリアント在庫切れ)なら購入導線を出さない。
        // 再販お知らせフォームがあるページでは登録導線に切り替える
        const allSoldOut = this.state.product &&
            this.state.product.variants.every(v => !v.available);
        const restockEl = document.getElementById('RestockNotify');

        if (allSoldOut && restockEl) {
            container.classList.add('pasc-restock-mode');
            wrapper.appendChild(this.createRestockRegistration(restockEl));
            container.appendChild(wrapper);
            return;
        } else if (allSoldOut) {
            btn.textContent = '完売';
            btn.disabled = true;
            btn.style.opacity = '0.6';
            qtyStepper.style.display = 'none';
        } else {
            // 挙動はカート追加(複数バリアントは選択モーダル→カート追加)のため、ページ内CTAと文言を統一し混乱を防ぐ
            btn.textContent = 'カートに追加する';
            btn.addEventListener('click', () => this.handleMobileAddToCart());
        }

        wrapper.appendChild(avatar);
        wrapper.appendChild(qtyStepper);
        wrapper.appendChild(btn);
        container.appendChild(wrapper);
    }

    // 追従バーから同じ登録フォームを送信する。商品タグ・スパム対策は既存フォームに集約。
    createRestockRegistration(restockEl) {
        const box = document.createElement('div');
        box.className = 'pasc-restock-registration';
        const form = restockEl.querySelector('#RestockNotifyForm');
        const original = form && form.querySelector('input[type="email"]');
        const status = document.createElement('p');
        status.className = 'pasc-restock-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        if (!original) {
            status.textContent = '登録済みです。販売開始をメールでお知らせします。';
            box.appendChild(status);
            return box;
        }
        const input = document.createElement('input');
        input.type = 'email';
        input.className = 'pasc-restock-email';
        input.placeholder = 'メールアドレス';
        input.setAttribute('aria-label', '販売開始のお知らせを受け取るメールアドレス');
        input.autocomplete = 'email';
        input.required = true;
        input.value = original.value;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pasc-sticky-btn pasc-restock-submit';
        btn.textContent = '販売開始をメールで受け取る';
        input.addEventListener('input', () => { original.value = input.value; });
        const submit = () => {
            if (btn.disabled || !input.reportValidity()) return;
            original.value = input.value.trim();
            form.requestSubmit();
        };
        btn.addEventListener('click', submit);
        input.addEventListener('keydown', event => {
            if (event.key === 'Enter' && !event.isComposing) {
                event.preventDefault();
                submit();
            }
        });
        box.appendChild(input);
        box.appendChild(btn);
        box.appendChild(status);
        return box;
    }

    updateRestockStatus() {
        const restockEl = document.getElementById('RestockNotify');
        const box = this.elements?.container.querySelector('.pasc-restock-registration');
        if (!restockEl || !box) return;
        const state = restockEl.dataset.state;
        const btn = box.querySelector('.pasc-restock-submit');
        const input = box.querySelector('.pasc-restock-email');
        if (!btn || !input) return;
        btn.disabled = state === 'pending' || state === 'success';
        input.disabled = btn.disabled;
        btn.textContent = state === 'pending' ? '登録中…' : '販売開始をメールで受け取る';
        if (state === 'success') {
            input.hidden = true;
            btn.hidden = true;
            box.querySelector('.pasc-restock-status').textContent = '登録完了。販売開始をメールでお知らせします。';
        }
    }

    handleMobileAddToCart() {
        if (!this.state.product) return;

        const variants = this.state.product.variants;
        if (variants.length > 1) {
            // モーダルにモバイルの数量を引き継ぐ
            this.state.quantities.modal = this.state.quantities.mobile || 1;
            this.openAdvancedVariantModal();
        } else {
            const qty = this.getStickyQty('mobile');
            this.addToCart(variants[0].id, qty, true);
        }
    }

    // --- Advanced Variant Modal (Multi-Step) ---
    openAdvancedVariantModal() {
        const existing = document.getElementById('pasc-variant-modal');
        if (existing) existing.remove();

        const modal = document.createElement('div');
        modal.id = 'pasc-variant-modal';
        modal.className = 'pasc-modal-overlay';

        const content = document.createElement('div');
        content.className = 'pasc-modal-content';

        this.modalContent = content; // Store ref for re-rendering content
        this.renderModalContent(content, modal);

        modal.appendChild(content);
        document.body.appendChild(modal);
        document.body.classList.add('pasc-modal-open'); // 開いてる間はチャット/お見積りバナーを隠す

        modal.addEventListener('click', (e) => {
            if (e.target === modal) { modal.remove(); document.body.classList.remove('pasc-modal-open'); }
        });
    }

    renderModalContent(contentContainer, modalInstance) {
        contentContainer.innerHTML = ''; // Clear previous render

        // 1. Header with Close Button
        const header = document.createElement('div');
        header.className = 'pasc-modal-header';
        // header.innerHTML = `<h3>オプションを選択</h3>`;
        // Close button
        const closeBtn = document.createElement('button');
        closeBtn.className = 'pasc-modal-close-icon';
        closeBtn.innerHTML = '&times;';
        closeBtn.onclick = () => { modalInstance.remove(); document.body.classList.remove('pasc-modal-open'); };
        header.appendChild(closeBtn);
        contentContainer.appendChild(header);

        // 2. Summary Box
        // Shows "Selection: Color Black / Size M - Price"
        const summaryBox = document.createElement('div');
        summaryBox.className = 'pasc-summary-box';
        const currentPrice = this.state.currentVariant ? this.formatMoney(this.state.currentVariant.price) : '選択してください';
        const selectionText = this.getSelectionText();
        summaryBox.innerHTML = `
          <div class="pasc-summary-label">選択中:</div>
          <div class="pasc-summary-value">${selectionText}</div>
          <div class="pasc-summary-price">${currentPrice}</div>
      `;
        contentContainer.appendChild(summaryBox);

        // 3. Option Steps
        const scrollArea = document.createElement('div');
        scrollArea.className = 'pasc-scroll-area';

        // voltera-jacket/voltera-pants: 3軸を2段階で完結（STEP2でoption2+option3を結合表示）
        const twoStepHandles = ['voltera-jacket', 'voltera-pants'];
        const isTwoStepProduct = twoStepHandles.includes(this.state.product.handle);
        const optionsToShow = isTwoStepProduct && this.state.product.options.length >= 3
            ? [this.state.product.options[0]] // STEP1のみループ、STEP2は別処理
            : this.state.product.options;

        optionsToShow.forEach((optionName, index) => {
            const stepContainer = document.createElement('div');
            stepContainer.className = 'pasc-step-container';

            const stepLabel = document.createElement('div');
            stepLabel.className = 'pasc-step-label';
            stepLabel.textContent = `[STEP${index + 1}] ${optionName}を選択してください`;
            stepContainer.appendChild(stepLabel);

            const optionsGrid = document.createElement('div');
            optionsGrid.className = 'pasc-options-grid';

            // Get values for this option
            // We need to filter values if they are dependent?
            // For simplicity in standard Shopify, we show all values for the option,
            // usually standard themes filter Step 2 based on Step 1.
            // Let's implement "filtering Step 2 based on Step 1".

            const values = this.getValuesForOption(index);

            values.forEach(value => {
                const btn = document.createElement('button');
                btn.className = 'pasc-option-btn';

                // Check if selected
                const isSelected = this.state.selectedOptions[optionName] === value;
                if (isSelected) btn.classList.add('selected');

                // Check availability (Mock or Real logic)
                // Complex logic: Check if (Selected Previous Options + This Value) has ANY valid variant.
                const isAvailable = this.checkAvailability(optionName, value);
                if (!isAvailable) {
                    btn.classList.add('disabled');
                    btn.disabled = true;
                }

                // Find variant image for this option value
                const variantWithImage = this.getVariantImageForOptionValue(index, value);
                let imgHTML = '';
                if (variantWithImage) {
                    imgHTML = `<img class="pasc-opt-img" src="${variantWithImage}" alt="${value}">`;
                }

                // Inner Content
                let btnHTML = `${imgHTML}<span class="pasc-opt-name">${value}</span>`;

                // If last Step, show Price/Stock status for this specific variant combo
                if (index === this.state.product.options.length - 1) {
                    const variant = this.getVariantForPotentialSelection(optionName, value);
                    if (variant) {
                        const stockText = variant.available ? '<span class="stock-in">✓ 在庫あり</span>' : '<span class="stock-out">× 在庫切れ</span>';
                        const priceText = this.formatMoney(variant.price);
                        btnHTML += `<div class="pasc-opt-meta">${priceText}</div>`;
                        btnHTML += `<div class="pasc-opt-stock">${stockText}</div>`;
                    }
                }

                btn.innerHTML = btnHTML;

                btn.onclick = () => {
                    this.handleOptionSelect(optionName, value);
                    this.renderModalContent(contentContainer, modalInstance); // Re-render whole modal
                };

                optionsGrid.appendChild(btn);
            });

            stepContainer.appendChild(optionsGrid);
            scrollArea.appendChild(stepContainer);
        });

        // voltera-jacket/voltera-pants専用: STEP2でoption2+option3を結合表示
        if (isTwoStepProduct && this.state.product.options.length >= 3) {
            const step2Container = document.createElement('div');
            step2Container.className = 'pasc-step-container';

            const step2Label = document.createElement('div');
            step2Label.className = 'pasc-step-label';
            step2Label.textContent = '[STEP2] オプションを選択してください';
            step2Container.appendChild(step2Label);

            const step2Grid = document.createElement('div');
            step2Grid.className = 'pasc-options-grid';

            // STEP1で選択されたサイズに基づいてバリエーションをフィルタリング
            const selectedOption1 = this.state.selectedOptions[this.state.product.options[0]];
            const filteredVariants = selectedOption1
                ? this.state.product.variants.filter(v => v.option1 === selectedOption1)
                : [];

            filteredVariants.forEach(variant => {
                const btn = document.createElement('button');
                btn.className = 'pasc-option-btn';

                // option2 + option3 を結合した表示名
                const displayName = variant.option3 && variant.option3 !== 'なし'
                    ? `${variant.option2} / ${variant.option3}`
                    : variant.option2;

                // 選択状態の判定（option2とoption3両方が一致）
                const isSelected = this.state.selectedOptions[this.state.product.options[1]] === variant.option2 &&
                                   this.state.selectedOptions[this.state.product.options[2]] === variant.option3;
                if (isSelected) btn.classList.add('selected');

                // 在庫状態
                if (!variant.available) {
                    btn.classList.add('disabled');
                    btn.disabled = true;
                }

                // バリエーション画像
                let imgHTML = '';
                if (variant.featured_image && variant.featured_image.src) {
                    const imgSrc = variant.featured_image.src.replace(/\.([^.]+)$/, '_100x100.$1');
                    imgHTML = `<img class="pasc-opt-img" src="${imgSrc}" alt="${displayName}">`;
                }

                // 価格と在庫状態
                const stockText = variant.available ? '<span class="stock-in">✓ 在庫あり</span>' : '<span class="stock-out">× 在庫切れ</span>';
                const priceText = this.formatMoney(variant.price);

                btn.innerHTML = `${imgHTML}<span class="pasc-opt-name">${displayName}</span><div class="pasc-opt-meta">${priceText}</div><div class="pasc-opt-stock">${stockText}</div>`;

                btn.onclick = () => {
                    // option2とoption3を同時に選択
                    this.state.selectedOptions[this.state.product.options[1]] = variant.option2;
                    this.state.selectedOptions[this.state.product.options[2]] = variant.option3;
                    this.state.currentVariant = variant;
                    this.renderModalContent(contentContainer, modalInstance);
                };

                step2Grid.appendChild(btn);
            });

            step2Container.appendChild(step2Grid);
            scrollArea.appendChild(step2Container);
        }

        // 3.5 同時購入(合わせ買い)セクション
        this.renderCrossSell(scrollArea);

        contentContainer.appendChild(scrollArea);

        // 4. Sticky Footer in Modal (Buy Button)
        const footer = document.createElement('div');
        footer.className = 'pasc-modal-footer';

        const buyBtn = document.createElement('button');
        buyBtn.className = 'pasc-modal-buy-btn';
        buyBtn.textContent = 'カートに追加する';

        // モーダル内にも数量ステッパーを追加
        const modalQty = this.createQtyStepper('modal');
        footer.appendChild(modalQty);

        if (this.state.currentVariant && this.state.currentVariant.available) {
            buyBtn.disabled = false;
            buyBtn.onclick = () => {
                const qty = this.getStickyQty('modal');
                // 本体(サイズ) ＋ チェックした同時購入品をまとめて追加
                var items = [{ id: this.state.currentVariant.id, quantity: qty }];
                contentContainer.querySelectorAll('[data-pasc-cross]:checked').forEach(function (cb) {
                    var id = parseInt(cb.dataset.vid, 10); if (id) items.push({ id: id, quantity: 1 });
                });
                if (items.length > 1) {
                    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
                        .then(function (r) { if (r.ok) window.location.href = '/cart'; });
                } else {
                    this.addToCart(this.state.currentVariant.id, qty, true);
                }
                modalInstance.remove();
            };
        } else {
            buyBtn.disabled = true;
            buyBtn.textContent = this.state.currentVariant ? '在庫切れ' : '選択してください';
            buyBtn.style.opacity = '0.6';
        }

        footer.appendChild(buyBtn);
        contentContainer.appendChild(footer);
    }

    // Logic Helpers
    getValuesForOption(optionIndex) {
        // Return unique values for this option index
        // Simple approach: Return all values from product.options[i].values?
        // But `product.options` is just an array of names in the JS JSON unless we parse variants.
        // Wait, {{ product | json }} usually has .options as ["Color", "Size"]
        // and .variants as objects.

        // We need to extract unique values from variants for this index.
        // option1 = index 0, option2 = index 1
        const key = `option${optionIndex + 1}`;
        const values = new Set();
        this.state.product.variants.forEach(v => {
            values.add(v[key]);
        });
        return Array.from(values);
    }

    getVariantImageForOptionValue(optionIndex, value) {
        // Find variant with this option value that has an image
        // For 2nd+ options, also consider already selected previous options
        const key = `option${optionIndex + 1}`;

        // Build filter based on current selections + this value
        const variant = this.state.product.variants.find(v => {
            // Must match the current option value
            if (v[key] !== value) return false;

            // Must have an image
            if (!v.featured_image || !v.featured_image.src) return false;

            // For options after the first, also match already selected options
            for (let i = 0; i < optionIndex; i++) {
                const prevOptName = this.state.product.options[i];
                const prevOptKey = `option${i + 1}`;
                if (this.state.selectedOptions[prevOptName] &&
                    v[prevOptKey] !== this.state.selectedOptions[prevOptName]) {
                    return false;
                }
            }

            return true;
        });

        if (variant && variant.featured_image) {
            // Return smaller size for thumbnail
            return variant.featured_image.src.replace(/\.([^.]+)$/, '_100x100.$1');
        }

        // Fallback: If no image found with current selection, try to find any image for this option value
        const fallbackVariant = this.state.product.variants.find(v => {
            return v[key] === value && v.featured_image && v.featured_image.src;
        });

        if (fallbackVariant && fallbackVariant.featured_image) {
            return fallbackVariant.featured_image.src.replace(/\.([^.]+)$/, '_100x100.$1');
        }

        return null;
    }

    checkAvailability(currentOptionName, currentValue) {
        // Copy current selection
        const potentiallySelected = { ...this.state.selectedOptions };
        potentiallySelected[currentOptionName] = currentValue;

        return this.state.product.variants.some(v => {
            // Must be available (in stock)
            if (!v.available) return false;

            // Check if variant matches all potential selection keys
            let match = true;
            this.state.product.options.forEach((optName, idx) => {
                const optKey = `option${idx + 1}`;
                if (potentiallySelected[optName] && v[optKey] !== potentiallySelected[optName]) {
                    match = false;
                }
            });
            return match;
        });
    }

    getVariantForPotentialSelection(currentOptionName, currentValue) {
        // Construct a full selection set assuming this value is chosen
        const tempSelection = { ...this.state.selectedOptions };
        tempSelection[currentOptionName] = currentValue;

        // Check if we have a FULL selection (all options chosen)
        if (Object.keys(tempSelection).length < this.state.product.options.length) {
            return null; // Not fully selected yet
        }

        // Find the specific variant
        return this.state.product.variants.find(v => {
            return this.state.product.options.every((optName, idx) => {
                const optKey = `option${idx + 1}`;
                return v[optKey] === tempSelection[optName];
            });
        });
    }

    handleOptionSelect(optionName, value) {
        // Update Selection
        this.state.selectedOptions[optionName] = value;

        // If this was Step 1, and Step 2 was already selected but is now invalid, clear Step 2?
        // For now, simpler to just keep it and let the re-render show it as invalid/unavailable if needed.
        // But clearing downstream selections is better UX.
        const optIndex = this.state.product.options.indexOf(optionName);
        // Clear options after this index
        for (let i = optIndex + 1; i < this.state.product.options.length; i++) {
            const nextOptName = this.state.product.options[i];
            delete this.state.selectedOptions[nextOptName];
        }

        // Check if full selection is made
        if (Object.keys(this.state.selectedOptions).length === this.state.product.options.length) {
            // Find variant
            this.state.currentVariant = this.state.product.variants.find(v => {
                return this.state.product.options.every((optName, idx) => {
                    const optKey = `option${idx + 1}`;
                    return v[optKey] === this.state.selectedOptions[optName];
                });
            });
        } else {
            this.state.currentVariant = null;
        }
    }

    getSelectionText() {
        // "Black / M"
        const parts = [];
        this.state.product.options.forEach(optName => {
            if (this.state.selectedOptions[optName]) {
                parts.push(this.state.selectedOptions[optName]);
            }
        });
        return parts.join(' / ') || '未選択';
    }

    // --- End Variant Logic ---

    // 数量ステッパーUI生成（stateから初期値取得、変更時にstateへ保存）
    createQtyStepper(context) {
        const self = this;
        const stepper = document.createElement('div');
        stepper.className = 'pasc-qty-stepper';
        stepper.dataset.context = context;

        const minus = document.createElement('button');
        minus.className = 'pasc-qty-btn pasc-qty-minus';
        minus.textContent = '−';
        minus.type = 'button';

        const display = document.createElement('span');
        display.className = 'pasc-qty-value';

        const plus = document.createElement('button');
        plus.className = 'pasc-qty-btn pasc-qty-plus';
        plus.textContent = '＋';
        plus.type = 'button';

        // stateから初期値を取得
        let qty = self.state.quantities[context] || 1;

        const update = () => {
            display.textContent = qty;
            minus.disabled = qty <= 1;
            stepper.dataset.qty = qty;
            self.state.quantities[context] = qty;
        };

        minus.addEventListener('click', (e) => {
            e.stopPropagation();
            if (qty > 1) { qty--; update(); }
        });

        plus.addEventListener('click', (e) => {
            e.stopPropagation();
            qty++;
            update();
        });

        stepper.appendChild(minus);
        stepper.appendChild(display);
        stepper.appendChild(plus);
        update();
        return stepper;
    }

    // stateから数量を取得
    getStickyQty(context) {
        return this.state.quantities[context] || 1;
    }

    async addToCart(variantId, qty, isDirectCheckout = false) {
        try {
            if (isDirectCheckout) {
                const btn = document.querySelector('.pasc-sticky-btn') || document.querySelector('.pasc-modal-buy-btn');
                if (btn) btn.textContent = '処理中...';
            }

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
            });

            if (response.ok) {
                if (isDirectCheckout) {
                    window.location.href = '/checkout';
                } else {
                    this.openPanel(); // Fallback for desktop if used there
                }
            } else {
                alert('追加に失敗しました。');
                const btn = document.querySelector('.pasc-sticky-btn') || document.querySelector('.pasc-modal-buy-btn');
                if (btn) btn.textContent = '追加する';
            }
        } catch (e) {
            console.error(e);
            alert('エラーが発生しました。');
        }
    }

    // ページ側の購入フォームで選ばれているバリエーションを state に取り込み、追従ウィジェットの価格を合わせる（2026-10-21）
    syncWithPageVariant() {
        const product = this.state.product;
        if (!product || !product.variants) return;
        const sel = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (!sel || !sel.value) return;
        const variant = product.variants.find(v => String(v.id) === String(sel.value));
        if (!variant) return;
        if (this.state.currentVariant && this.state.currentVariant.id === variant.id && this.lastSyncedVariantId === variant.id) return;
        this.lastSyncedVariantId = variant.id;
        this.state.currentVariant = variant;
        // モーダル（購入する）を開いたときにも同じ選択が入っているようにする
        (product.options || []).forEach((optName, idx) => {
            const val = variant['option' + (idx + 1)];
            if (val != null) this.state.selectedOptions[optName] = val;
        });
        this.renderStickyPrice(variant);
    }

    // 追従ウィジェットの価格表示。variant があればその価格、無ければ商品全体の価格帯（最安値〜）
    renderStickyPrice(variant) {
        const el = this.stickyPriceEl;
        const product = this.state.product;
        if (!el || !product) return;
        el.textContent = '';
        const addSale = (compareAt, priceText) => {
            const originalPrice = document.createElement('span');
            originalPrice.className = 'pasc-price-original';
            originalPrice.textContent = this.formatMoney(compareAt);
            el.appendChild(originalPrice);
            const salePrice = document.createElement('span');
            salePrice.className = 'pasc-price-sale';
            salePrice.textContent = priceText;
            el.appendChild(salePrice);
        };
        if (variant) {
            if (variant.compare_at_price > variant.price) {
                addSale(variant.compare_at_price, this.formatMoney(variant.price));
            } else {
                el.textContent = this.formatMoney(variant.price);
            }
            return;
        }
        const variants = product.variants || [];
        const prices = variants.map(v => v.price).filter(p => p > 0);
        const minPrice = prices.length > 0 ? Math.min(...prices) : (product.price || 0);
        const maxPrice = prices.length > 0 ? Math.max(...prices) : minPrice;
        const hasVariantPriceRange = minPrice !== maxPrice;
        // セール表示は「本当に値引きされているバリエーションがある」ときだけ（一覧カードと同じ基準。
        // 整備済み品に通常価格＝販売価格が入っているだけの商品を、セールに見せない）
        const saleVariants = variants.filter(v => v.compare_at_price > v.price);
        if (saleVariants.length > 0) {
            const compareAtPrice = Math.max(...saleVariants.map(v => v.compare_at_price));
            addSale(compareAtPrice, this.formatMoney(minPrice) + (hasVariantPriceRange ? '~' : ''));
        } else {
            el.textContent = this.formatMoney(minPrice) + (hasVariantPriceRange ? '~' : '');
        }
    }

    formatMoney(cents) {
        if (!cents) return '';
        const yen = Math.floor(cents / 100);
        return `¥${yen.toLocaleString('ja-JP')}`;
    }

    // --- Desktop Widget Stubs (Unchanged) ---
    // --- Desktop Sticky Bar (Right Side - Rakuten Style) ---
    renderDesktopStickyBar(container) {
        const product = this.state.product;

        // 完売判定(モバイル版と同じ基準)。
        // 再販お知らせフォームの無いただの完売商品では、購入ポップアップ自体を出さない
        const allSoldOut = product && product.variants &&
            product.variants.every(v => !v.available);
        const restockEl = document.getElementById('RestockNotify');
        if (allSoldOut && !restockEl) return;

        container.classList.add('pasc-desktop-sticky');
        const wrapper = document.createElement('div');
        wrapper.className = 'pasc-sticky-wrapper';

        // 商品画像（メイン画像を使用）
        const avatar = document.createElement('div');
        avatar.className = 'pasc-sticky-avatar';
        const img = document.createElement('img');
        // 商品のメイン画像を取得（Shopify product JSONの構造に対応）
        let productImage = '';
        if (product) {
            productImage = product.featured_image ||
                          (product.images && product.images[0]) ||
                          (product.media && product.media[0] && product.media[0].src) || '';
        }
        if (!productImage) {
            productImage = window.powerarqCartWidgetConfig?.iconUrl || '';
        }
        img.src = productImage;
        img.alt = product?.title || 'Product';
        avatar.appendChild(img);

        // 商品名
        const title = document.createElement('div');
        title.className = 'pasc-sticky-title';
        title.textContent = product?.title || '';

        // 価格（バリエーション対応・セール対応）。ページ側で選んだバリエーションに追従する（2026-10-21）
        const priceContainer = document.createElement('div');
        priceContainer.className = 'pasc-sticky-price';
        this.stickyPriceEl = priceContainer;
        // ページが「選択しているバリエーションの価格」として単一の価格を出している商品（選択軸が1つ）は、最初からその価格に合わせる。
        // 複数軸の商品はページ側も選ぶまで価格帯を出すので、ウィジェットも価格帯のまま
        if (document.getElementById('current-variant-price-display')) {
            this.syncWithPageVariant();
        } else {
            this.renderStickyPrice(null);
        }

        // 数量ステッパー + 購入ボタン
        // (再販お知らせ対象の完売商品では、購入UIの代わりにメール登録導線を出す)
        const actionRow = document.createElement('div');
        actionRow.className = 'pasc-sticky-action-row';

        if (allSoldOut && restockEl) {
            container.classList.add('pasc-restock-mode');
            actionRow.appendChild(this.createRestockRegistration(restockEl));
        } else {
            const qtyStepper = this.createQtyStepper('desktop');
            actionRow.appendChild(qtyStepper);

            const btn = document.createElement('button');
            btn.className = 'pasc-sticky-btn';
            btn.textContent = '購入する';
            btn.addEventListener('click', () => this.handleDesktopAddToCart());
            actionRow.appendChild(btn);
        }

        wrapper.appendChild(avatar);
        wrapper.appendChild(title);
        wrapper.appendChild(priceContainer);
        wrapper.appendChild(actionRow);
        container.appendChild(wrapper);

        // スクロールで表示/非表示を切り替え
        this.setupDesktopScrollListener(container);
    }

    // デスクトップ版: 商品画像がビューポートを超えたらスティッキーバーを表示
    setupDesktopScrollListener(container) {
        // 商品画像/カートボタンのセレクタ（複数候補から探す）
        const triggerSelectors = [
            '.product-single__photos',
            '.product__photos',
            '.product-single__media-wrapper',
            '.product-featured-img',
            '[data-product-photos]',
            '.product-single__media',
            '.product__media-list',
            '.product-form__cart-submit',
            '[name="add"]',
            '.product-form'
        ];

        let triggerEl = null;
        for (const selector of triggerSelectors) {
            triggerEl = document.querySelector(selector);
            if (triggerEl) break;
        }

        if (!triggerEl) {
            // トリガー要素が見つからない場合は常に表示
            container.classList.add('pasc-desktop-sticky--visible');
            return;
        }

        const checkVisibility = () => {
            const rect = triggerEl.getBoundingClientRect();
            // トリガー要素の下端がビューポートの半分より上にきたら表示
            const threshold = window.innerHeight * 0.5;
            if (rect.bottom < threshold) {
                container.classList.add('pasc-desktop-sticky--visible');
            } else {
                container.classList.remove('pasc-desktop-sticky--visible');
            }
        };

        // 初回チェック
        checkVisibility();

        // スクロール時にチェック（パフォーマンス対策でthrottle）
        let ticking = false;
        window.addEventListener('scroll', () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    checkVisibility();
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });
    }

    handleDesktopAddToCart() {
        if (!this.state.product) return;

        const variants = this.state.product.variants;
        if (variants.length > 1) {
            // モーダルにデスクトップの数量を引き継ぐ
            this.state.quantities.modal = this.state.quantities.desktop || 1;
            this.openAdvancedVariantModal();
        } else {
            const qty = this.getStickyQty('desktop');
            this.addToCart(variants[0].id, qty, true);
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { window.powerarqStickyCart = new PowerArQStickyCart(); });
} else {
    window.powerarqStickyCart = new PowerArQStickyCart();
}
